// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-next',
  revision: 'dec418c8a',
  branch: 'next',
  date: 'Mon, 23 Mar 2026 11:06:07 GMT'
};